import { valNit } from 'src/selectors/utilities.selector'
import {
  EPayType,
  getFilesByType,
} from 'src/content/CardProviders/CardProvider/Forms/Pagalo/utils/TypePagaloBusiness'
import { haveAnyValue } from 'src/utils/utilitiesV2'

interface IPagaloValidateResponse {
  isOk: boolean
  error?: string
  request?: IPagaloRequest
}

export const onValidate = (data: IPagaloForm): IPagaloValidateResponse => {
  const request: IPagaloRequest = {
    email: data.email,
    password: data.password,

    name: data.name,
    phone: data.phone,
    nit: data.nit,
    dpi: data.dpi,

    nameBusiness: data.nameBusiness,
    category: data.category?.value,
    typeBusiness: data.typeBusiness?.label,

    bankId: data.bank?.value ? Number(data.bank?.value) : null,
    files: data.files,
  }
  if (!valNit(request.nit) || request.nit.toLowerCase() === 'cf')
    return { isOk: false, error: 'Debe indicar un NIT valido' }
  else if (!request.dpi || request.dpi.length !== 13)
    return { isOk: false, error: 'Debe indicar un DPI valido' }
  else {
    const fileTypes = getFilesByType(data.typeBusiness.value as EPayType)
    if (
      !haveAnyValue(request.files) ||
      fileTypes.length === 0 ||
      request.files.length !== fileTypes.length ||
      request.files.some(f => !f.file)
    )
      return { isOk: false, error: 'Todos los archivos deben estar cargados.' }
    else {
      const withEmpty = Object.values(request).some(value => !haveAnyValue(value))
      if (withEmpty) return { isOk: false, error: 'Todos los campos son obligatorios' }
      else {
        return { isOk: true, request }
      }
    }
  }
}
